/**
 * Portal Manta · GuiaPage
 * Extraído de App.jsx (v29 modular)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V, S } from '../../globals.js';

const GuiaPage = memo(function GuiaPage_Inner(){
  return(<div style={S.page}>
    <div style={S.h1}>📘 Guia de uso do portal</div>
    <div style={S.sub}>Como navegar e onde encontrar cada análise no portal Manta Lotes PR · v8</div>
    <div style={{...S.card,padding:'14px 18px',marginBottom:12,fontSize:11.5,lineHeight:1.7,color:V.br}}>
      <h3 style={{fontSize:13,fontWeight:700,color:V.br,marginBottom:6}}>1. Estrutura geral</h3>
      <p>O portal tem <b>2 abas principais</b> no topo: <b>Orçamentação</b> (análise por lote) e <b>Gestão do Conhecimento</b> (KB cross-lote, agentes, glossário).</p>
      <h3 style={{fontSize:13,fontWeight:700,color:V.br,marginTop:12,marginBottom:6}}>2. Modo Orçamentação</h3>
      <p>Selecione um lote (L3, L4 ou L5) na sidebar de formações. As sidebars colapsam automaticamente (modo foco) — clique em "◀ Mostrar menu" para expandir.</p>
      <p>Páginas do lote (em ordem):</p>
      <ul style={{paddingLeft:22,marginTop:6,marginBottom:8}}>
        <li><b>1 · Consolidado do Lote</b> — Dashboard + Financeiro + Fatores Qualitativos (do lote)</li>
        <li><b>2 · Serviços × Rodovias</b> — KPIs por serviço, por rodovia, totais e Curva ABC</li>
        <li><b>3 · Agentes (Executar)</b> — console de agentes IA: Diagnóstico, Comparativo, Leitor, etc.</li>
        <li><b>4 · Tipologias × Rodovia</b> — Tipologias, Tipologia × Rodovia, Comparativo L3·L4·L5, Escopo consolidado por segmento</li>
        <li><b>5 · Obras × Rodovia</b> — sidebar de rodovias, retigráfico esquemático, contexto qualitativo, KPIs físicos, SICRO detalhado</li>
        <li><b>6 · Dados Manta</b> — Compara Paramétrico, Paramétrico Manta (com volumes, top 5, fixos × variáveis), Macro + Estrutura</li>
        <li><b>7 · Documentos</b> — links para PER, MEF, edital, normas</li>
      </ul>
      <h3 style={{fontSize:13,fontWeight:700,color:V.br,marginTop:12,marginBottom:6}}>3. Modo Gestão do Conhecimento</h3>
      <p>Sidebar à esquerda com <b>3 grupos</b>:</p>
      <ul style={{paddingLeft:22,marginTop:6,marginBottom:8}}>
        <li><b>1 · KPIs</b> — Gestão de Orçamento, Diagnóstico do Portal (validador), Comparativo entre lotes</li>
        <li><b>2 · KB Curada e demais</b> — bibliotecas, normas, simulações, busca RAG, prompts, camada de dados</li>
        <li><b>3 · Glossário, Guia & Novo Orçamento</b> — esta página, glossário, motor de novo orçamento via KB</li>
      </ul>
      <h3 style={{fontSize:13,fontWeight:700,color:V.br,marginTop:12,marginBottom:6}}>4. Filtros aplicados</h3>
      <p>As páginas 2-7 do menu por lote estão filtradas para mostrar apenas <b>obras de ampliação</b> (badge azul "OBRAS DE AMPLIAÇÃO" no h1). A página 1 (Consolidado) mantém todos os tipos de obras (TI + REC + MANUT + Ampliação).</p>
      <h3 style={{fontSize:13,fontWeight:700,color:V.br,marginTop:12,marginBottom:6}}>5. Rastreabilidade</h3>
      <p>Cada sub-aba tem código numérico (ex.: 2.3, 6.2) na breadcrumb superior — facilita referência cruzada.</p>
      <h3 style={{fontSize:13,fontWeight:700,color:V.br,marginTop:12,marginBottom:6}}>6. Validações automáticas</h3>
      <p>O <b>Diagnóstico do Portal</b> (Conhecimento → KPIs → B) varre os 3 lotes × seções e mostra ✓/✕/⚠ por campo. Use sempre que importar dados novos.</p>
    </div>
  </div>);
});

export { GuiaPage };
export default GuiaPage;
